import { AnimatedSpriteWrap } from "common/pixi/animatedSprite";
import { Sheets } from "common/sheets";
export class Background {
    constructor(pixiContext, sheets) {
        const textures = Sheets.animationTextures(sheets, fileName);
        // const textures = R.flatten(
        //   R.map((sheet: Sheet) => sheet.animationTextures(fileName), sheets),
        // );
        const sprite = new AnimatedSpriteWrap(pixiContext, textures);
        sprite.anchor.set(0.5, 0.5);
        this.sprite = sprite;
        this.sprite.animationSpeed = 0.3;
    }
}
export const fileName = "background";
//# sourceMappingURL=background.js.map